import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_ffffff = setTheme(({ theme }) => `background-color: ${theme.colors.color_ffffff}`);
